import { render, staticRenderFns } from "./Symbols.vue?vue&type=template&id=23a63d32"
import script from "./Symbols.vue?vue&type=script&lang=js"
export * from "./Symbols.vue?vue&type=script&lang=js"
import style0 from "./Symbols.vue?vue&type=style&index=0&id=23a63d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports